<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <div class="headline">Reserve Category Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <span slot="activator">
                {{ props.header.text }}
              </span>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.resCat }}</td>
            <td class="text-xs-left">{{ props.item.resCatShortDesc }}</td>
            <td class="text-xs-left">{{ props.item.resCatLongDesc }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :review="checkAccess(['claimReview'])" @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div class="pt-2">
        <v-btn color="primary" @click.native="doNew()">
          New Claim Reserve Category
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="reserveCategoryDialog" width="800px" lazy v-if="checkAccess(['claimReview'])" persistent >
        <reserve-category-dialog :clmResCatForm="clmResCatForm" @close="doClose" :newClmResCat="newClmResCat"></reserve-category-dialog>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Reserve Categoty? ({{deleteClmResCat}})
      </confirm>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import ReserveCategoryDialog from './ReserveCategoryDialog'

export default {
  data() {
    return {
      headers: [
        { text: 'Reserve Catgory', align: 'left', value: 'resCat' },
        { text: 'Short Description', align: 'left', value: 'resCatShortDesc' },
        { text: 'Long Description', align: 'left', value: 'resCatLongDesc' }
      ],
      clmResCatForm: {
        resCat: undefined,
        resCatShortDesc: undefined,
        resCaLongDesc: undefined
      },
      reserveCategoryDialog: undefined,
      newClmResCat: undefined,
      loading: false,
      promptRemove: false,
      selectedClmResCat: undefined,
      deleteClmResCat: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    async fetchData() {
      this.loading = true
      const apiUrl = this.$store.state.claimParam.menu.getClmResCats
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((ClmResCat) => {
              const convertClmResCat = {
                resCat: ClmResCat.resCat,
                resCatShortDesc: ClmResCat.resCatShortDesc,
                resCatLongDesc: ClmResCat.resCatLongDesc
              }
              this.items.push(convertClmResCat)
            })
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      }
    },
    async doReview(ResCat) {
      const apiURI = this.$store.state.claimParam.menu.getClmResCat
      const expand = {
        resCat: ResCat.item.resCat
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.clmResCatForm.resCat = data.resCat.resCat
          this.clmResCatForm.resCatShortDesc = data.resCat.resCatShortDesc
          this.clmResCatForm.resCatLongDesc = data.resCat.resCatLongDesc
        }
        this.reserveCategoryDialog = true
      }
    },
    doClose() {
      this.reserveCategoryDialog = false
      this.newClmResCat = false
      this.$validator.reset()
      this.fetchData()
    },
    doNew() {
      this.$validator.reset()
      this.reserveCategoryDialog = true
      this.newClmResCat = true
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedClmResCat = data
        this.deleteClmResCat = data.resCat + ' - ' + data.resCatShortDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.claimParam.menu.deleteClmResCat
      if (apiURI) {
        this.loading = true
        const expand = {
          resCat: this.selectedClmResCat.resCat
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData()
  },
  created() {
    if (this.checkAccess(['claimReview'])) {
      this.headers.push(TableConst.tableActionHeader)
    }
  },
  components: {
    ReserveCategoryDialog: ReserveCategoryDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
